import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useHistory } from 'react-router-dom';
import { AiFillLike, AiOutlineLike } from 'react-icons/ai';
import api from '../../services/api';
import FeedLayout from '../Includes/FeedLayout';
import Perfil from '../../assests/avatar.png';
import { calculaTempo } from '../../global';

import './styles.css';

export default function Escalas() {
  const { t } = useTranslation();
  const history = useHistory();
  const BASE_URL = sessionStorage.getItem('BASE_URL');
  const sentinelRef = useRef(null);
  const loadingRef = useRef(false);

  const [posts, setPosts] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loadingMore, setLoadingMore] = useState(false);
  const [zoomImg, setZoomImg] = useState(null);

  const USER_EMAIL = sessionStorage.getItem('email');
  const USER_TOKEN = sessionStorage.getItem('token');
  const PARAMS = '';

  useEffect(() => {
    let cancelled = false;
    loadingRef.current = true;
    setLoadingMore(true);

    api.get(`/v4/posts?page=${page}&by_kind=scale`, {
      headers: {
        USER_EMAIL,
        USER_TOKEN,
        PARAMS,
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (cancelled) return;
      const data = Array.isArray(response.data) ? response.data : [];
      setPosts((prev) => (page === 1 ? data : prev.concat(data)));
      setHasMore(data.length > 0);
      sessionStorage.setItem('sPosts', JSON.stringify(data));
      sessionStorage.setItem('page', page);
    }).catch(() => {
      if (!cancelled) history.push('/');
    }).finally(() => {
      if (!cancelled) {
        loadingRef.current = false;
        setLoadingMore(false);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [USER_EMAIL, USER_TOKEN, history, page]);

  useEffect(() => {
    const el = sentinelRef.current;
    if (!el) return undefined;
    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      if (loadingRef.current || !hasMore) return;
      setPage((current) => current + 1);
    }, { rootMargin: '240px' });
    observer.observe(el);
    return () => observer.disconnect();
  }, [hasMore, posts.length]);

  useEffect(() => {
    if (!zoomImg) return undefined;
    function onKey(e) {
      if (e.key === 'Escape') setZoomImg(null);
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [zoomImg]);

  function abrirDetalhe(post) {
    sessionStorage.setItem('sPostDetalhe', JSON.stringify(post));
  }

  function Description(props) {
    const texto = String(props.texto || '').substring(0, 220);
    return (
      <p className="description">{texto}</p>
    );
  }

  function curtir(id, evaluation) {
    const nextValue = evaluation === null ? true : null;
    var axios = require('axios');
    var data = JSON.stringify({ evaluation: nextValue });
    var config = {
      method: 'post',
      url: BASE_URL + `/v6/posts/${id}/evaluate`,
      headers: {
        'Content-Type': 'application/json',
        USER_EMAIL,
        USER_TOKEN,
      },
      data,
    };
    axios(config)
      .then(function () {
        setPosts((prev) => prev.map((post) => {
          if (post.id !== id) return post;
          const liked = nextValue === true;
          const count = parseInt(post.ups_count, 10) || 0;
          return {
            ...post,
            evaluation: liked,
            ups_count: liked ? count + 1 : Math.max(0, count - 1),
          };
        }));
      })
      .catch(function () {});
  }

  function Like(props) {
    if (props.evaluation === true) {
      return (
        <button type="button" onClick={() => curtir(props.id, props.evaluation)}>
          <AiFillLike size={18} color="#00b8ff" />
          <span className="like">{props.count}</span>
        </button>
      );
    }
    return (
        <button type="button" onClick={() => curtir(props.id, null)}>
          <AiOutlineLike size={18} color="#6b7280" />
          <span className="like">{props.count}</span>
        </button>
    );
  }

  function Imagem(props) {
    if (!props.url || props.url === 'null') return null;
    return (
      <img
        className="feed-photo"
        src={props.url}
        alt=""
        onClick={() => setZoomImg(props.url)}
      />
    );
  }

  return (
    <FeedLayout active="scales">
      <div className="escalas-container">
        <div className="feed-top">
          {t('pages.includes.header.scales')}
        </div>
        <section className="feed-body">
          <ul>
            {posts.map((post) => (
              <li key={post.id}>
                <div className="post-content">
                  <p className="nomeProf">
                    <img
                      className="imgProf"
                      src={post.user && post.user.avatar && post.user.avatar.medium ? post.user.avatar.medium : Perfil}
                      alt=""
                    />
                    <span>
                      <span className="nome">{post.user && post.user.name}</span>
                      <span className="tempo"> · {calculaTempo(post.created_at)}</span>
                    </span>
                  </p>
                  <div className="containerTag">
                    <div className="tags">
                      {(post.tags || []).map((tag) => (
                        <span key={tag.id}>{tag.name}</span>
                      ))}
                    </div>
                  </div>
                  <p className="title">{post.title}</p>
                  <Description texto={post.description} />
                  <Imagem
                    url={post.image ? (post.image.original || post.image.medium) : null}
                  />
                  <p className="lermais">
                    <Link
                      to={`/escala/${post.id}`}
                      className="lermais"
                      onClick={() => abrirDetalhe(post)}
                    >
                      {t('pages.scales.more')}
                    </Link>
                  </p>
                  <p className="icons">
                    <Like count={post.ups_count} id={post.id} evaluation={post.evaluation} />
                  </p>
                </div>
              </li>
            ))}
          </ul>
          <div className="feed-sentinel" ref={sentinelRef}>
            {loadingMore && <span>Carregando mais escalas…</span>}
            {!loadingMore && !hasMore && posts.length > 0 && (
              <span>Você viu as escalas mais recentes</span>
            )}
          </div>
        </section>
      </div>
      {zoomImg && (
        <div className="img-zoom" onClick={() => setZoomImg(null)} role="dialog" aria-modal="true">
          <button type="button" className="img-zoom-close" onClick={() => setZoomImg(null)} aria-label="Fechar">×</button>
          <img src={zoomImg} alt="" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </FeedLayout>
  );
}
